import React, { ComponentType } from 'react';

function withSlice<T, U>(
  Component: ComponentType<U>,
  normalizer: (data: T) => U | null,
) {
  return React.memo(function SliceWrapper(sliceContent: T) {
    const normalizedProps = normalizer(sliceContent);

    if (!normalizedProps) {
      return null;
    }

    return <Component {...normalizedProps} />;
  });
}

export default withSlice;
